
(function() {
    'use strict';

    console.log('TikTok Discount JS loaded');
    console.log('mb-tik-tok-discount-validator.vercel.app');

    // Configuration
    const API_URL = window.location.hostname === 'localhost' 
  ? 'http://localhost:3002' 
  : 'https://mb-tik-tok-discount-validator.vercel.app';

    // Section elements
    const sections = {
        form: null,
        product: null,
        success: null,
        error: null
    };

    // Other elements
    let form, submitBtn, btnText, loader, responseMessage;
    let countryCodeSelect, customCountryCode, phoneHelp;
    let productList, productLoading, discountCodeDisplay, errorMessage;
    let currentCustomerId = null;

    // Initialize when DOM is ready
    document.addEventListener('DOMContentLoaded', function() {
        initializeElements();
        attachEventListeners();
    });

    function initializeElements() {
        // Get sections
        sections.form = document.getElementById('formSection');
        sections.product = document.getElementById('productSection');
        sections.success = document.getElementById('successSection');
        sections.error = document.getElementById('errorSection');

        // Get form elements
        form = document.getElementById('discountForm');
        submitBtn = document.getElementById('submitBtn');
        btnText = document.getElementById('btnText');
        loader = document.getElementById('loader');
        responseMessage = document.getElementById('responseMessage');

        // Get other elements
        countryCodeSelect = document.getElementById('countryCode');
        customCountryCode = document.getElementById('customCountryCode');
        phoneHelp = document.getElementById('phoneHelp');
        productList = document.getElementById('productList');
        productLoading = document.getElementById('productLoading');
        discountCodeDisplay = document.getElementById('discountCodeDisplay');
        errorMessage = document.getElementById('errorMessage');
    }

    function attachEventListeners() {
        // Form submission
        if (form) {
            form.addEventListener('submit', handleFormSubmit);
        }

        // Country code selector
        if (countryCodeSelect) {
            countryCodeSelect.addEventListener('change', handleCountryCodeChange);
        }

        // Real-time validation
        const nameInput = document.getElementById('name');
        const phoneInput = document.getElementById('phone');

        if (nameInput) {
            nameInput.addEventListener('blur', function() {
                validateName(this.value);
            });
        }

        if (phoneInput) {
            phoneInput.addEventListener('blur', function() {
                validatePhone(this.value);
            });
        }
    }

    function handleCountryCodeChange() {
        if (countryCodeSelect.value === 'other') {
            customCountryCode.classList.remove('hidden');
            customCountryCode.focus();
            phoneHelp.textContent = 'Enter country code (e.g., +33) and phone number';
        } else {
            customCountryCode.classList.add('hidden');
            customCountryCode.value = '';
            phoneHelp.textContent = 'Enter your phone number without the country code';
        }
    }

    function showSection(sectionName) {
        // Hide all sections
        Object.values(sections).forEach(section => {
            if (section) section.classList.add('hidden');
        });

        // Show requested section
        if (sections[sectionName]) {
            sections[sectionName].classList.remove('hidden');
        }
    }

    function validateName(name) {
        const errorElement = document.getElementById('nameError');
        if (name.trim().length < 2 || name.trim().length > 100) {
            errorElement.textContent = 'Name must be between 2 and 100 characters';
            return false;
        }
        errorElement.textContent = '';
        return true;
    }

    function validatePhone(phone) {
        const errorElement = document.getElementById('phoneError');
        const digitsOnly = phone.replace(/\D/g, '');

        if (digitsOnly.length < 5) {
            errorElement.textContent = 'Phone number is too short (minimum 5 digits)';
            return false;
        }
        if (digitsOnly.length > 15) {
            errorElement.textContent = 'Phone number is too long (maximum 15 digits)';
            return false;
        }

        errorElement.textContent = '';
        return true;
    }

    async function handleFormSubmit(e) {
        e.preventDefault();

        // Get form values
        const name = document.getElementById('name').value;
        const phone = document.getElementById('phone').value;
        let countryCode = countryCodeSelect.value;

        // Handle custom country code
        if (countryCode === 'other') {
            countryCode = customCountryCode.value;
            if (!countryCode || !countryCode.startsWith('+')) {
                document.getElementById('phoneError').textContent = 'Please enter a valid country code starting with +';
                return;
            }
        }

        // Validate inputs
        if (!validateName(name) || !validatePhone(phone)) {
            return;
        }

        // Check terms
        const termsCheckbox = document.getElementById('terms');
        if (!termsCheckbox.checked) {
            document.getElementById('termsError').textContent = 'You must agree to the Terms of Service';
            return;
        }
        document.getElementById('termsError').textContent = '';

        const fullPhone = countryCode + phone.replace(/^0+/, '');

        // Show loading state
        submitBtn.disabled = true;
        btnText.classList.add('hidden');
        loader.classList.remove('hidden');
        responseMessage.classList.add('hidden');

        try {
            // Call validation API
            const response = await fetch(`${API_URL}/api/validate-discount`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ name, phone: fullPhone })
            });

            const data = await response.json();
            console.log('Validation response:', data);

            if (data.success && data.eligible) {
                if (data.requiresProductSelection) {
                    // Customer is eligible - show product selection
                    currentCustomerId = data.customerId;
                    await showProductSelection();
                } else if (data.discountCode) {
                    // Direct discount code (shouldn't happen in this flow)
                    showSuccessSection(data.discountCode);
                }
            } else {
                // Show error in form
                responseMessage.innerHTML = data.message || 'Unable to verify eligibility';
                responseMessage.className = 'response-message error';
                responseMessage.classList.remove('hidden');
            }
        } catch (error) {
            console.error('Error:', error);
            responseMessage.innerHTML = 'An error occurred. Please try again.';
            responseMessage.className = 'response-message error';
            responseMessage.classList.remove('hidden');
        } finally {
            submitBtn.disabled = false;
            btnText.classList.remove('hidden');
            loader.classList.add('hidden');
        }
    }

    async function showProductSelection() {
        // Switch to product section
        showSection('product');

        // Show loading
        productLoading.style.display = 'block';
        productList.style.display = 'none';

        try {
            // Fetch products from API
            const response = await fetch(`${API_URL}/api/eligible-products`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include'
            });

            const data = await response.json();
            console.log('Products response:', data);

            if (data.success && data.products && data.products.length > 0) {
                displayProducts(data.products);
            } else {
                // Fallback to hardcoded products
                displayProducts(getHardcodedProducts());
            }
        } catch (error) {
            console.error('Error fetching products:', error);
            // Use hardcoded products as fallback
            displayProducts(getHardcodedProducts());
        } finally {
            productLoading.style.display = 'none';
            productList.style.display = 'grid';
        }
    }

    function getHardcodedProducts() {
        return [
            {
                id: 8049630085165,
                title: 'Fluffer G-Thing Bulb Vibe',
                description: 'Premium wireless internal vibration',
                image: null
            },
            {
                id: 8049631035437,
                title: 'Fluffer G2G Panty Vibe',
                description: 'Discreet and powerful panty vibe',
                image: null
            },
            {
                id: 8049634967597,
                title: 'Fluffer Rock Hard Power Ring',
                description: 'Ultimate power ring experience',
                image: null
            }
        ];
    }

    function displayProducts(products) {
        productList.innerHTML = '';

        // Create form to hold radio buttons
        const form = document.createElement('form');
        form.id = 'productSelectionForm';

        products.forEach((product, index) => {
            // Create product card as a label
            const label = document.createElement('label');
            label.className = 'product-card';
            label.setAttribute('for', `product${index}`);

            // Create radio input
            const radio = document.createElement('input');
            radio.type = 'radio';
            radio.name = 'productId';
            radio.id = `product${index}`;
            radio.value = product.id;
            radio.className = 'product-radio';
            radio.required = true;

            // Create selection indicator
            const indicator = document.createElement('div');
            indicator.className = 'selection-indicator';

            // Create product info container
            const infoDiv = document.createElement('div');
            infoDiv.className = 'product-info';

            // Create product image or placeholder
            let imageHTML = '';
            if (product.image) {
                imageHTML = `<img src="${product.image}" alt="${product.title}" class="product-image">`;
            } else {
                imageHTML = `<div class="product-image" style="display: flex; align-items: center; justify-content: center; color: #ccc;">
                    <span>No Image</span>
                </div>`;
            }

            // Create product details
            const detailsHTML = `
                <div class="product-details">
                    <div class="product-name">${product.title}</div>
                    <div>
                        ${product.price ? `<span class="product-price">$${product.price}</span>` : ''}
                        <span class="free-badge">FREE</span>
                    </div>
                    ${product.description ? `<div class="product-description">${product.description}</div>` : ''}
                </div>
            `;

            infoDiv.innerHTML = imageHTML + detailsHTML;

            // Assemble the card
            label.appendChild(radio);
            label.appendChild(indicator);
            label.appendChild(infoDiv);

            // Add event listener for selection
            radio.addEventListener('change', function() {
                // Remove selected class from all cards
                document.querySelectorAll('.product-card').forEach(card => {
                    card.classList.remove('selected');
                });

                // Add selected class to parent card
                if (this.checked) {
                    label.classList.add('selected');
                }
            });

            form.appendChild(label);
        });

        // Add submit button
        const submitBtn = document.createElement('button');
        submitBtn.type = 'submit';
        submitBtn.className = 'submit-btn';
        submitBtn.style.marginTop = '20px';
        submitBtn.innerHTML = '<span>Get My Free Product</span>';

        form.appendChild(submitBtn);

        // Add form submit handler
        form.addEventListener('submit', function(e) {
            e.preventDefault();

            const selectedProduct = document.querySelector('input[name="productId"]:checked');
            if (selectedProduct) {
                selectProduct(selectedProduct.value);
            }
        });

        productList.appendChild(form);
    }

    async function selectProduct(productId) {
        console.log('Product selected:', productId);

        // Show loading state in product section
        productList.style.opacity = '0.5';
        productList.style.pointerEvents = 'none';

        try {
            // Generate discount for selected product
            const response = await fetch(`${API_URL}/api/generate-discount`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({
                    customerId: currentCustomerId,
                    productId: productId
                })
            });

            const data = await response.json();
            console.log('Discount response:', data);

            if (data.success && data.discountCode) {
                showSuccessSection(data.discountCode);
            } else {
                showErrorSection(data.message || 'Failed to generate discount code');
            }
        } catch (error) {
            console.error('Error generating discount:', error);
            showErrorSection('An error occurred while generating your discount code');
        }
    }

    function showSuccessSection(discountCode) {
        discountCodeDisplay.textContent = discountCode;
        showSection('success');

        // Reset form for potential future use
        if (form) form.reset();
    }

    function showErrorSection(message) {
        if (errorMessage) {
            errorMessage.textContent = message;
        }
        showSection('error');
    }

    // Global function for reset button
    window.resetForm = function() {
        // Reset everything and show form
        if (form) form.reset();
        currentCustomerId = null;
        responseMessage.classList.add('hidden');
        showSection('form');
    };
})();